/* src/app/components/user-audit-list/user-audit-list/user-audit-list.component.css */
.comment-textarea {
  min-height: 100px !important;
}
/*# sourceMappingURL=user-audit-list.component.css.map */
